import httpClient from './httpClient';

const END_POINT = '/api/languages';

const getAllLanguages = () => httpClient.get(END_POINT + '.json');

export { getAllLanguages };
